module.exports = __webpack_public_path__ + "static/media/banner-1.d4c60659.jpg";